import clsx from "clsx";
import { XIcon } from "lucide-react";

interface ModalLayoutProps {
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
  renderFooter?: () => React.ReactNode;
  className?: string;
}

const ModalLayout = ({
  title,
  onClose,
  children,
  renderFooter,
  className,
}: ModalLayoutProps) => {
  return (
    <div
      className={clsx(
        "w-full bg-background mx-auto rounded-2xl relative z-50 flex flex-col",
        className,
      )}
    >
      {title ? (
        // Modal with title - header with title and close button
        <>
          <div className="px-6 py-4 flex items-center justify-between gap-4 border-b">
            <span className="text-xl font-medium flex-1 pr-2">{title}</span>
            <button
              onClick={onClose}
              className="flex-shrink-0 hover:opacity-70 transition-opacity"
            >
              <XIcon />
            </button>
          </div>

          <div className="px-6 py-4 overflow-y-auto" style={{ maxHeight: "70vh" }}>
            {children}
          </div>
        </>
      ) : (
        // Modal without title - close button positioned absolutely
        <>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 flex-shrink-0 hover:opacity-70 transition-opacity bg-background/80 p-2 rounded-lg"
          >
            <XIcon className="h-5 w-5" />
          </button>

          <div className="px-6 py-6 overflow-y-auto" style={{ maxHeight: "70vh" }}>
            {children}
          </div>
        </>
      )}

      {renderFooter && (
        <div className="border-t border-bgDisabled px-6 py-4">{renderFooter()}</div>
      )}
    </div>
  );
};

export default ModalLayout;
